var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClockIcon = function SvgClockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "clock-icon_svg__\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 200 200"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clock-icon_svg__cls-1{fill:#fff}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 12.5a87.49 87.49 0 1 0 87.47 87.5A87.57 87.57 0 0 0 100 12.5Zm0 162.44a75 75 0 1 1 75-75 75 75 0 0 1-75 75Z",
    className: "clock-icon_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M131.26 100H100V56.27a6.25 6.25 0 1 0-12.5 0v50a6.23 6.23 0 0 0 6.25 6.24h37.49a6.27 6.27 0 1 0 0-12.53Z",
    className: "clock-icon_svg__cls-1"
  })));
};
export default SvgClockIcon;